import {Form, Input, message, Modal, ModalProps} from 'antd';
import React, {useContext} from 'react';
import Style from './index.module.scss';
import {ColumnEntityItem, editColumn} from '../../service';
import {errorMessage} from 'Utils/common';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import SelectDict from 'Features/Select/SelectDict';
import {useDict} from '../../../../store';
import {ColumnContext} from '../../context';

interface Props extends ModalProps {
    data?: ColumnEntityItem;
    onOk: () => void;
}

const Index = ({data, onOk, ...props}: Props) => {
    const dict = useDict();
    const {siteId} = useContext(ColumnContext);
    const [form] = Form.useForm<ColumnEntityItem>();
    const [save, {loading: saveLoading}] = useRequestFn(editColumn);

    async function onFinish(formData: ColumnEntityItem) {
        try {
            if (data) {
                formData.id = data.id;
            }
            formData.siteId = siteId;
            await save(formData);
            message.success('编辑成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            width={600}
            title="编辑栏目"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    labelCol={{span: 5}}
                    initialValues={data}>
                    <Form.Item
                        name="catname"
                        label="栏目名称"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="caturl"
                        label="域名"
                        rules={[
                            {required: true},
                            {
                                pattern: /^(http:\/\/|https:\/\/).*$/,
                                message: '必须以http://或https://开头',
                            },
                        ]}>
                        <Input placeholder="请输入完整域名 例如: https://www.edufe.com" />
                    </Form.Item>
                    <Form.Item
                        name="cattype"
                        label="栏目类型"
                        rules={[{required: true}]}>
                        <SelectDict options={dict.ColumnType.data} />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
